var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 7,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.777 45.3333H31.2215C26.7025 45.3333 23.6666 42.1639 23.6666 37.4457V26.5556C23.6666 21.8375 26.7025 18.6667 31.2215 18.6667H42.7784C47.2974 18.6667 50.3333 21.8375 50.3333 26.5556V37.4457C50.3333 42.1639 47.2974 45.3333 42.777 45.3333Z",
    fill: "#D20E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5711 33.4528C41.8671 33.0648 42.9658 31.8515 44.3858 32.7155C45.2911 33.2595 46.0525 33.9955 46.8671 34.7835C47.1778 35.0848 47.4005 35.4288 47.5471 35.7955C47.9911 36.9048 47.7605 38.2381 47.2858 39.3368C46.7231 40.6448 45.6458 41.6328 44.2885 42.0648C43.6858 42.2581 43.0538 42.3408 42.4231 42.3408H31.2485C30.1365 42.3408 29.1525 42.0821 28.3458 41.5968C27.8405 41.2928 27.7511 40.5928 28.1258 40.1368C28.7525 39.3768 29.3711 38.6141 29.9951 37.8448C31.1845 36.3728 31.9858 35.9461 32.8765 36.3208C33.2378 36.4755 33.6005 36.7088 33.9738 36.9541C34.9685 37.6128 36.3511 38.5168 38.1725 37.5355C39.4258 36.8501 40.1498 35.6741 40.7818 34.6555C41.0405 34.2408 41.2858 33.8275 41.5711 33.4528ZM32.6799 24.252C34.5066 24.252 35.9933 25.74 35.9933 27.5667C35.9933 29.3933 34.5066 30.88 32.6799 30.88C30.8519 30.88 29.3666 29.3933 29.3666 27.5667C29.3666 25.74 30.8519 24.252 32.6799 24.252Z",
    fill: "#FBFBFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.3125,
    y: 0.625,
    width: 73.375,
    height: 73.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.0625,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.3125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.3125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageRounded);
export default __webpack_public_path__ + "static/media/image-rounded.e58779e5.svg";
export { ForwardRef as ReactComponent };